import { useWeb3Context } from "@/contexts/web3";
import { useMarginlyApi } from "@/hooks/api";

const MOCK_PRICES: Record<`0x${string}`, number> = {
  //PT-amphrLRT-26SEP2024
  "0x96056fC19b633a662FE0366c8cDd38C371407De4": 2942,
  //PT-agETH-26DEC2024
  "0x7aa68E84bCD8d1B4C9e10B1e565DB993f68a3E09": 2451,
  //amphrLRT
  "0x06824C27C8a0DbDe5F72f770eC82e3c0FD4DcEc3": 2968,
  //agETH
  "0xe1B4d34E8754600962Cd944B535180Bd758E6c2e": 2567,
  //PT-weETH-26DEC2024
  "0x6ee2b5E19ECBa773a352E5B21415Dc419A700d1d": 2475,
};

export function usePrices() {
  const { internalChainId } = useWeb3Context();

  const { data } = useMarginlyApi({
    enabled: Boolean(internalChainId),
    endpoint: "prices",
    args: [internalChainId],
  });

  const priceByToken = data?.tokens.reduce((acc, { address, priceInUsd }) => {
    acc[address] = priceInUsd;
    return acc;
  }, {} as Record<`0x${string}`, number>);

  if (!priceByToken) {
    return undefined;
  }

  return { ...priceByToken, ...MOCK_PRICES };
}
